import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=4c8f9a41&"
import script from "./CompanyManagement.vue?vue&type=script&lang=js&"
export * from "./CompanyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports